import React, { useMemo } from "react";
import { NavUtils, exportView } from "../../navigation";
import { Row } from "./components";
import { isNonEmptyArray } from "../../common/utils";
import styles from "./MainMenu.module.css";
import { Flags, isFeatureEnabled, translate } from "../../common/providers";

const MainMenu = () => {
  const menus = useMemo(
    () => [
      {
        title: translate("main-menu.find-inspiration-title"),
        subText: translate("main-menu.find-inspiration-sub-text"),
        path: NavUtils.gotoMultiProjectSearch(),
        featureFlag: Flags.WRITE_PLUGIN,
      },
      {
        title: translate("main-menu.req-to-deliv-title"),
        subText: translate("main-menu.req-to-deliv-sub-text"),
        path: NavUtils.gotoLinkReqToDev(),
        featureFlag: Flags.COVERAGE_PLUGIN,
      },
    ],
    []
  );
  return (
    <div className={styles.container}>
      {isNonEmptyArray(menus) &&
        menus.filter((menu) => isFeatureEnabled(menu.featureFlag)).map((menu) => <Row key={menu.title} menu={menu} />)}
    </div>
  );
};

export default exportView({
  path: "/main-menu",
  component: MainMenu,
  localesPath: "/main-menu/locales",
});
